import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {endOfISOWeek, endOfMonth, startOfISOWeek, startOfMonth} from 'date-fns';
import {TicketService, CustomerService} from 'src/app/services';
import {debounceTime, switchMap, takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {getDateHelper} from "../../../shared/common/helper";
@Component({
  selector: 'app-log-call-ticket',
  templateUrl: './log-call-ticket.component.html',
  styleUrls: ['./log-call-ticket.component.scss']
})
export class LogCallTicketComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject();
  search$ = new Subject();
  dateRange = [];
  customers = [];
  isLoading = false;
  callId;
  customerId;
  priority;
  status;
  from;
  to;
  page = 1;
  pageSize = 10;
  query;
  ranges1: any;
  // tslint:disable-next-line:variable-name
  now_month: any;
  // tslint:disable-next-line:variable-name
  list_id = [];
  data = [];
  loading = false;
  total = 0;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  changeAction = undefined;
  // tslint:disable-next-line:variable-name
  width_window = 0;
  // @ts-ignore
  @ViewChild('noteModal') noteModal;
  // @ts-ignore
  @ViewChild('delete') delete;
  constructor(
    private ticketService: TicketService,
    private notification: NzNotificationService,
    private customerService: CustomerService,
  ) {
    this.search$.asObservable().pipe(
      debounceTime(500),
    ).subscribe(
      res => {
        const query = {
          keyword: res
        };
        this.customerService.list(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
          response => {
            if (response.code === 1) {
              this.customers = response.data.items;
            }
          }
        );
      }
    );
  }

  ngOnInit() {
    this.width_window = window.innerWidth;
    const x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 1);
    this.now_month = x;
    this.ranges1 = {
      'Hôm nay': [new Date(), new Date()],
      'Hôm qua': [new Date(new Date().getTime() - 24 * 60 * 60 * 1000), new Date(new Date().getTime() - 24 * 60 * 60 * 1000)],
      'Tuần trước': [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date()],
      'Tuần này': [startOfISOWeek(new Date()), endOfISOWeek(new Date())],
      'Tháng trước': [startOfMonth(new Date(this.now_month)), endOfMonth(new Date(this.now_month))],
      '30 ngày gần nhất': [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), new Date()],
    };
    this.loadData();
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
  }
  loadData() {
    this.loading = true;
    this.query = {
      page: this.page,
      page_size: this.pageSize,
    };
    if (this.from !== undefined) {
      this.query.from = this.from;
    }
    if (this.to !== undefined) {
      this.query.to = this.to;
    }
    if (this.priority !== undefined) {
      this.query.priority = this.priority;
    }
    if (this.status !== undefined) {
      this.query.status = this.status;
    }
    if (this.callId !== undefined) {
      this.query.callId = this.callId;
    }
    if (this.customerId !== undefined) {
      this.query.customerId = this.customerId;
    }
    this.ticketService.getListTicket(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.data = res.data.items;
          this.total = res.data.totalElement;
          this.refreshStatus();
          return;
        }
        this.notification.error(
          'Có lỗi xảy ra',
          res.message
        );
      },
      error => {
        this.notification.error(
          'Có lỗi xảy ra',
          error
        );
      }
    );
  }
  search() {
    this.page = 1;
    this.loadData();
  }
  reset() {
    const arr = [ 'callId', 'customerId', 'priority', 'status', 'from', 'to'];
    arr.map(key => {
      this[key] = undefined;
    });
    this.dateRange = [];
    this.page = 1;
    this.mapOfCheckedId = {};
    this.loadData();
  }
  onChange(event) {
    if (event.length === 2) {
      this.from = this.getDate(event[0]);
      this.to = this.getDate(event[1]);
    }
  }
  searchCustomer(event) {
    this.search$.next(event);
  }
  detailTicket(id) {
    this.ticketService.detailTicket(id).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.noteModal.showNote(res.data, 'update');
        }
      }
    );
  }
  updateTicket(event) {
    let body: any;
    body = event.value;
    body.id = event.id;
    this.ticketService.updateTicket(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.noteModal.hideNote();
          this.notification.success(
            'Thành công',
            'Cập nhật ghi chú thành công'
          );
          this.loadData();
          return;
        }
        this.notification.error(
          'Cập nhật thất bại',
          res.message
        );
      },
      error => {
        this.notification.error(
          'Cập nhật thất bại',
          error.message
        );
      }
    );
  }
  fDelete(type: boolean, id: any) {
    if (type && id) {
      const data  = {
        label: 'Xác nhận xóa  ghi chú',
        value: 'Hệ thống sẽ xóa ghi chú này.Bạn có chắc chắn muốn xóa?'
      };
      this.delete.showModal(data, [id]);
      return;
    }
    if (this.list_id.length) {
      const data  = {
        label: 'Xác nhận xóa nhiều ghi chú',
        value: 'Hệ thống sẽ xóa nhũng ghi chú này.Bạn có chắc chắn muốn xóa?'
      };
      this.delete.showModal(data, this.list_id);
    }
  }
  handleDelete(event) {
    const query = {
      ids: event.toString()
    };
    this.ticketService.deleteTicket(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.notification.success(
            'Thành công',
            'Xóa ghi chú thành công'
          );
          this.delete.success();
          this.delete.handleCancel();
          this.mapOfCheckedId = {};
          this.list_id = [];
          this.changeAction = undefined;
          this.loadData();
          return;
        }
        this.notification.error(
          'Xóa ghi chú thất bại',
          res.message
        );
      },
      error => {
        this.notification.error(
          'Xóa ghi chú thất bại',
          error.message
        );
      }
    );
  }
  checkAll(value: boolean) {
    this.data.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }

  refreshStatus() {
    if (this.data.length > 0) {
      this.isAllDisplayDataChecked = this.data.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.data.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }
  buttonSubmit() {
    if (this.changeAction === 1) {
      this.fDelete(false, '');
    }
  }
  getDate(date) {
    return getDateHelper(date);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
